{
  "fr": {
    "pagination": {
      "previous": "Page précédente",
      "next": "Page suivante",
      "page_report": "Page {page} sur {total}",
      "report": "Affichage de {first} à {last} sur {total}",
      "total": "Total des éléments : {total}"
    }
  }
}
